<template>
  <section class="form__content">
    <h3>1. {{ $t('datesOfStay.title') }}</h3>

    <v-form v-model="formValidation">
      <v-radio-group :label="$t('periodOfStay.label')"
                     :value="period"
                     @change="$emit('update:period', $event)"
                     required
                     :rules="[v => !!v || $t('error.required')]"
      >
        <v-radio v-for="item in items"
                 :key="item.value"
                 :value="item.value"
                 :label="item.label"
        />
      </v-radio-group>
    </v-form>
  </section>
</template>

<script>
export default {
  name: 'PeriodOfStay',

  props: {
    valid: {
      required: true,
    },
    dormitoryPeriodYear: {
      required: true,
    },
    dormitoryPeriodAutumn: {
      required: true,
    },
    dormitoryPeriodSpring: {
      required: true,
    },
    period: {
      required: true,
    },
  },

  data () {
    return {
      formValidation: false,
      items: [
        {
          label: this.dormitoryPeriodYear,
          value: 'dormitoryPeriod-year',
        },
        {
          label: this.dormitoryPeriodAutumn,
          value: 'dormitoryPeriod-autumn',
        },
        {
          label: this.dormitoryPeriodSpring,
          value: 'dormitoryPeriod-spring',
        },
      ],
    }
  },

  watch: {
    formValidation () {
      this.$emit('update:valid', this.formValidation)
    },
  },
}
</script>
